import Text from '@modules/common/components/text';

import type { OrderDetailData } from './types';
import CheckoutFormItem from './checkout-form-item';

interface ShippingInfoProps {
  order: OrderDetailData;
}

const ShippingInfo = ({ order }: ShippingInfoProps) => {
  const { company, phone, address_1, last_name } = order.shipping_address || {};

  return (
    <div className="border-white-40 bg-white-20 flex-1 rounded-md border p-6">
      <Text variant="title-bold" as="h4" className="mb-4">收件資訊</Text>
      <div className="flex flex-col gap-4">
        <CheckoutFormItem title="門市名稱" value={company || '-'} />
        <CheckoutFormItem title="收件人姓名" value={last_name || '-'} />
        <CheckoutFormItem title="收件人聯絡電話" value={phone || '-'} />
        <CheckoutFormItem title="收件地址" value={address_1 || '-'} />
      </div>
    </div>
  );
};

export default ShippingInfo;
